import { Button } from '@/components/elements/forms/buttons';
import Modal from '@/components/modules/modals/redesign/Modal/Modal';
import useMobileView from '@/hooks/useMobileView';
import { _t } from '@/locale';
import { ModalViews } from '../../GiftcardSelfServe.reducer';

const baseTranslation = 'features.giftcard-self-serve.components.modals.SuccessConfirmation';

const SuccessConfirmation = ({
  onClose,
  isOpen,
  modalView,
  buyerEmail,
}: {
  onClose: () => void;
  isOpen: boolean;
  modalView: ModalViews;
  buyerEmail: string;
}) => {
  const { isMobileView } = useMobileView();

  return (
    <Modal className={`${isMobileView ? 'h-screen' : 'md:max-w-[560px]'}`} isOpen={isOpen} onRequestClose={onClose}>
      <Modal.Content newDesign={true} contentPadding={false} floating={!isMobileView}>
        <Modal.Header
          newDesign={true}
          title={_t(`${baseTranslation}.${modalView === 'receiptConfirmation' ? 'receipt' : 'return'}.title`)}
          floating={!isMobileView}
          onClose={onClose}
        />
        <div className="flex justify-center">
          <div
            className={`py-xl gap-xs bg-surface_l4 flex h-full max-w-[376px] flex-col items-center ${
              isMobileView ? 'flex-1' : 'rounded-b-lg'
            }`}>
            <img className="h-[128px] w-[128px]" src="/images/illustrations/success-confirmation.png" alt="" />
            <h2 className="text-h-s text-fg_primary">
              {_t(
                `${baseTranslation}.${
                  modalView === 'receiptConfirmation' ? 'receipt.subTitle' : 'return.subTitleConfirmation'
                }`,
              )}
            </h2>
            <p className="text-fg_secondary text-center">
              {modalView === 'receiptConfirmation'
                ? _t(`${baseTranslation}.receipt.body`, { email: buyerEmail })
                : _t(`${baseTranslation}.return.body`)}
            </p>
          </div>
        </div>
        <div
          className={`bg-surface_l4 p-md border-border_regular flex justify-between border-t ${
            isMobileView ? '' : 'rounded-b-lg'
          }`}>
          <div className="flex w-full justify-end">
            <Button label={_t('close')} size="md" onClick={onClose} />
          </div>
        </div>
      </Modal.Content>
    </Modal>
  );
};

export default SuccessConfirmation;
